import { ExpandableBillListItem } from '../../../../components';
import { MonthListLabel } from '../MonthListLabel';
import { MonthServiceList } from '../MonthServiceList';

interface ServiceListProps {
    month: string;
    billId: string;
    accountId: string;
    scope: string;
    value: string;
    someSelected: boolean;
    allSelected: boolean;
    toggleSelect: () => void;
}

export const MonthListItem: React.FC<ServiceListProps> = ({
    month,
    billId,
    accountId,
    scope,
    someSelected,
    allSelected,
    toggleSelect,
    ...other
}) => {
    const primaryText = (
        <MonthListLabel
            billId={billId}
            scope={scope}
            month={month}
            someSelected={someSelected}
            allSelected={allSelected}
            toggleSelect={toggleSelect}
        />
    );
    return (
        <ExpandableBillListItem primaryText={primaryText} {...other} multiSelect>
            <MonthServiceList billId={billId} depth={0} month={month} accountId={accountId} />
        </ExpandableBillListItem>
    );
};
